import { render, staticRenderFns } from "./group-4.vue?vue&type=template&id=675b4a54&"
import script from "./group-4.vue?vue&type=script&lang=js&"
export * from "./group-4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports